@if (modalConfirmationDeleteAccountService.showModal()) {
  <div
    class="fixed inset-0 bg-gray-900/50 flex items-center justify-center z-50"
    >
    <div class="bg-white rounded-lg p-6 max-w-md w-full mx-4 shadow-lg">
      <div class="text-center">
        <h3 class="text-lg font-medium text-gray-900 mb-4">
          Confirmar eliminación
        </h3>
        <div class="bg-white p-4 rounded-lg shadow mb-6">
          <div class="flex items-center justify-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-8 w-8 text-red-500 mr-2"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                />
              </svg>
            </div>
          </div>
          <p class="text-gray-600 mb-6">
            ¿Estás seguro que deseas eliminar tu cuenta? Esta acción no se puede
            deshacer.
          </p>
          <div class="flex justify-center gap-4">
            <button
              (click)="confirmDeleteAccount()"
              class="p-3 bg-red-500 text-white rounded-full hover:bg-red-600 transition duration-200 flex items-center justify-center mr-4"
              aria-label="Confirmar"
              >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                  />
                </svg>
              </button>
              <button
                (click)="onCloseModal()"
                class="p-3 bg-gray-200 text-gray-800 rounded-full hover:bg-gray-300 transition duration-200 flex items-center justify-center"
                aria-label="Cancelar"
                >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      }

      <perfil-user-component-modal-confirmation-delete-input-code></perfil-user-component-modal-confirmation-delete-input-code>
